<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
  <div>
    <div class="d-flex justify-content-between" style="margin-bottom: 10px">
      <div>
        <p style="font-size: 12px">
          <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table row
          for more option.
        </p>
      </div>
      <b-button-group v-if="editableOps">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="refreshGrid"
          >Refresh</b-button
        >
      </b-button-group>
    </div>
    <DxDataGrid
      id="cement-int-grid"
      ref="cementIntGrid"
      :data-source="cementCirculationDataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      column-resize-mode="nextColumn"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :cell-hint-enabled="true"
      :word-wrap-enabled="true"
      :column-auto-width="false"
      :column-width="100"
      :height="300"
      @row-inserted="savedRows"
      @row-updated="updatedRows"
      @row-removed="removedRows"
    >
      <DxPaging :enabled="false"/>
      <DxSelection mode="single"/>
      <DxScrolling column-rendering-mode="virtual"/>
      <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          :use-icons="true"
          mode="row"/>
      <DxColumn v-for="column in tableFields" :key="column.key" :data-field="column.key" :caption="column.label" :data-type="column.type" />
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import { formMethods } from '@state/helpers'
import CustomStore from 'devextreme/data/custom_store'
import mapApiUrl from '@/src/utils/api-mapper'
import axios from 'axios'
import qs from 'querystring'

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    // DxFormItem,
    DxLookup,
    // DxForm,
    // DxSimpleItem,
    // DxGroupItem,
  },
  props: {
    submitId: {
      type: Number,
      default: undefined,
    },
    editableOps: {
      type: Boolean,
      default: false,
    },
    wellId: {
      type: Number,
      default: undefined,
    },
  },

  data() {
    return {
      cementCirculationDataSource: null,
      selectedRow: [],
      listItem: [],
      perPage: 10,
      tableBusy: false,
      currentPage: 1,
      tableFields: [
        { key: 'circulationType', label: 'Circulation Type', type: 'string' },
        { key: 'md', label: 'MD', type: 'number' },
        { key: 'flowRate', label: 'Flow Rate', type: 'number' },
        { key: 'objective', label: 'Objective', type: 'string' },
        { key: 'pressure', label: 'Pressure', type: 'number' },
        { key: 'timeOfCirculation', label: 'Time of Circulation', type: 'date' },
      ],
      selectedAction: '',
      form: [],
      show: false,
      stageNoList: [],
      cementIntIsLoading: false,
    }
  },

  computed: {
    totalRows: function () {
      return this.listItem.length
    },
  },

  watch: {
    submitId: function (val, oldVal) {
      this.refreshGrid()
    },
  },

  created: function () {
    this.init()
  },

  methods: {
    ...formMethods,
    init() {
      this.cementCirculationDataSource = new CustomStore({
        key: 'intId',
        load: () => {
          const url = mapApiUrl('/api/form/activity/cement/intcirculation/review')
          const params = {submitId: this.submitId, status: 1}
          return axios.get(url, {params: params}).then(response => response.data.data)
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          const url = mapApiUrl('/api/form/activity/cement/intcirculation/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.intId = key
          const url = mapApiUrl('/api/form/activity/cement/intcirculation/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/activity/cement/intcirculation/remove')
          return axios.delete(url, {params: {intId: key}})
        },
      })
    },
    refreshGrid() {
      this.$refs.cementIntGrid.instance.refresh()
    },
    savedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Intermediate circulation data has been recorded.`, width: 500 }, 'success', 3000)
    },
    updatedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Intermediate circulation data has been updated.`, width: 500 }, 'success', 3000)
    },
    removedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Intermediate circulation data has been removed.`, width: 500 }, 'success', 3000)
    },
    refreshTableAndCombo() {
      this.tableBusy = true
      this.listItem = []
      this.getActivityCementIntCirculation({
        params: { submitId: this.submitId },
      }).then((resp) => {
        this.listItem = resp.data.data
        this.tableBusy = false
      })
      this.loadAllCombo()
    },
    loadAllCombo() {},
    onRowSelected(item) {
      if (item.length === 0) {
        this.selectedRow = []
        this.$refs.tableDataCementIntCirc.clearSelected()
        return
      }
      this.selectedRow = item
      this.form = item[0]
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    saving(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      delete rowData.intId
      rowData.submitId = this.submitId
      this.addActivityCementIntCirculation({ params: rowData }).then((resp) => {
          this.retrieveDataTable()
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
      })
    },
    askServerToRemoveData() {
      if (this.selectedRow.length > 0) {
        const data = { ...this.selectedRow[0] }
        this.removeActivityCementIntCirculation({ params: data }).then(
          (resp) => {
            this.refreshTableAndCombo()
            this.closeModalRemove()
            this.makeToast(
              'Remove data cement intermediate circulation success.'
            )
          }
        )
      }
    },
  },
}
</script>